import CommunityProfileWelcome from './CommunityProfileWelcome'

export default CommunityProfileWelcome
